import { Button, Dialog, List } from "antd-mobile";
import $ from "jquery";
import React, { useState, useContext, useEffect } from "react";

import { Route, Switch, withRouter } from "react-router-dom";

import PsContext from "../../../context";
import Header from "./header";
import Footer from "./footer";
import Dashboard from "../dashboard";
import UgEdit from "../ugEdit";
import CourseApply from "../courseApply";
import PaymentStatus from "../paymentStatus";
import MyProfile from "../myProfile";
import axios from "axios";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { S3_BUCKET_HOME_PATH } from "../../../utils";

const UgAdmissionLayout = (props) => {
  const context = useContext(PsContext);

  useEffect(() => {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }, [props.location.pathname]);

  useEffect(() => {
    loadApplicantInfo();
  }, []);

  const loadApplicantInfo = () => {
    try {
      var form = new FormData();
      form.append("i__apiCode", context.user.api_code);
      //form.append("i__apiCode", context.user.api_code);
      axios.post(ServiceUrl.UG.APPLICANT_MIN_INFO, form).then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;
          context.updateUser(d);
        }
      });
    } catch (error) {}
  };

  return (
    <>
      <Header path={props.location.pathname || null} {...props} />
      <div className="inner-wrapper ">
        <section
          role="main "
          className="page-content"
          style={S3_BUCKET_HOME_PATH != "sxctvl/" ? { marginTop: "120px" } : {}}
        >
          <Switch>
            <Route path="/edit/:type" component={UgEdit} exact />
            <Route path="/apply" component={CourseApply} exact />
            <Route path="/my-profile" component={MyProfile} exact />
            <Route
              path="/payment-status/:uuid"
              component={PaymentStatus}
              exact
            />
            <Route path="/" component={Dashboard} />
          </Switch>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default withRouter(UgAdmissionLayout);
